<ng-template #content>
    @if (icon()) {
        <mat-icon class="pretty-easy-link__icon"
                  [svgIcon]="icon()">
        </mat-icon>
    }
    <span class="pretty-easy-link__label">{{ label() | translate }}</span>
</ng-template>

@if (routerLink()) {
    <!-- Use routerLink if provided -->
    <a class="pretty-easy-link__anchor"
        [ngClass]="formattedClasses()"
        [routerLink]="routerLink()"
        routerLinkActive="pretty-easy-link__anchor--active"
        [queryParams]="queryParams()"
        [fragment]="fragment()"
        [attr.data-label]="label()"
        [matTooltip]="isSidebarFolded ? (label() | translate) : null"
        [matTooltipPosition]="isSidebarFolded ? 'right' : null"
        (click)="onClick($event)">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
} @else {
    <a class="pretty-easy-link__anchor"
        [ngClass]="formattedClasses()"
        [href]="href()"
        [attr.data-label]="label()"
        [matTooltip]="isSidebarFolded ? (label() | translate) : null"
        [matTooltipPosition]="isSidebarFolded ? 'right' : null"
        (click)="onClick($event)">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
}